import { propagateTemplate } from '@/data/services/evaluationServices';
import Evaluation, { EvaluationTypeEnum } from '@/models/Evaluation';

import useMasterEvaluations from './useMasterEvaluations';
import useSlaveEvaluations from './useSlaveEvaluations';

type UseTemplatePropagationProps = {
  evaluation: Evaluation;
};

const useTemplatePropagation = ({
  evaluation,
}: UseTemplatePropagationProps) => {
  const courseLineId = evaluation.courseLineId ?? 0;

  const { evaluations, isLoading: isLoadingMasters } = useMasterEvaluations({
    courseLineId,
  });
  const {
    slavesByMaster,
    cacheManager,
    isLoading: isLoadingSlaves,
  } = useSlaveEvaluations({
    courseLineId,
    masters: evaluations,
  });

  const slaveEntries = slavesByMaster.get(evaluation.id) ?? [];
  const isLoading = isLoadingMasters || isLoadingSlaves;

  const propagate = async () => {
    if (evaluation.type !== EvaluationTypeEnum.TEMPLATE) return null;
    if (slaveEntries.length === 0) return null;

    const updatedSlaves = await propagateTemplate({
      templateId: evaluation.id,
    });

    cacheManager.batch(
      updatedSlaves.map(slave => () => cacheManager.update(slave)),
    );

    return updatedSlaves;
  };

  return { propagate, slaveEntries, cacheManager, isLoading };
};

export default useTemplatePropagation;
